import { Component } from 'react';
import PropTypes from 'prop-types';

class TriangleComponent extends Component {
  render() {
    return (
      <div className={this.props.classNames}>
        <svg x="0px" y="0px" viewBox="0 0 28.77 28.77" >
          <g>
            <g id="c105_arrow">
              <path d="M28.679,22.971l-13.967-17.7c-0.16-0.201-0.494-0.201-0.656,0L0.09,22.971c-0.099,0.13-0.118,0.3-0.05,0.447    c0.069,0.143,0.218,0.232,0.376,0.232H28.35c0.162,0,0.308-0.09,0.376-0.232C28.8,23.27,28.777,23.1,28.679,22.971z" />
            </g>
            <g id="Capa_1_169_" />
          </g>
        </svg>
      </div>
    );
  }
}

export default TriangleComponent;
